import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPanoramaView"><Path d="M23 6.55454C23 4.81813 21.2884 3.65214 19.6643 4.09394C14.4515 5.51191 9.54848 5.51191 4.33571 4.09394C2.7116 3.65214 1 4.81813 1 6.55454V17.4434C1 19.1855 2.72158 20.351 4.34827 19.9042C9.53549 18.4793 14.4645 18.4793 19.6517 19.9042C21.2784 20.351 23 19.1855 23 17.4434V6.55454Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPanoramaView;
